/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const rankingDetailsSchema = z.object({
  ownership: z.enum(['READ_ONLY', 'WRITE_ONLY', 'READ_WRITE']),
  scope: z.enum(['GLOBAL']),
});
